import { render } from "./callSetting.vue?vue&type=template&id=4c53bc1c"
import script from "./callSetting.vue?vue&type=script&lang=js"
export * from "./callSetting.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__